declare const PermissionIDSymbol: unique symbol
export type PermissionID = string & { [PermissionIDSymbol]: never }

export interface PermissionJson {
    id: string
    name: string
}

export class Permission {
    id: PermissionID
    name: string

    constructor(
        id: string,
        name: string,
    ) {
        this.id = id as PermissionID
        this.name = name
    }

    static fromJson(json: PermissionJson): Permission {
        return new Permission(
            json.id,
            json.name,
        )
    }
}